/*/
 * Navigation
/*/
	const siteNav = document.querySelectorAll('[site-nav-toggle]')

	if (siteNav) {
		siteNav.forEach(e => {
			const siteDocument = document.documentElement
			const siteNavElement = document.querySelector('.header--nav')

			e.addEventListener('click', _ => {
				if (siteDocument.classList.contains('is--nav')) {
					siteDocument.classList.remove('is--nav')

					setTimeout(() => {
						siteNavElement.classList.remove('d-none')
					}, 300);
				} else {
					siteNavElement.classList.remove('d-none')

					setTimeout(() => {
						siteDocument.classList.add('is--nav')
					}, 100);
				}
			})
		})
	}

	document.addEventListener('keyup', _ => {
		const siteDocument = document.documentElement

		if (siteDocument.classList.contains('is--nav') && _.key === 'Escape') {
			siteDocument.classList.remove('is--nav')
		}
	})

/*/
 * Dropdown collapse
/*/
	import { Dropdown, Collapse } from 'bootstrap5'

	const siteDrodownHeader = document.querySelectorAll('.dropdown')

	if (siteDrodownHeader) {
		siteDrodownHeader.forEach(e => {
			e.addEventListener('show.bs.dropdown', function (event) {
				const inset = e.querySelector('.dropdown-menu')
				const height = inset.querySelector('ul').offsetHeight + 18
				inset.style.setProperty('--height', `${height}px`)
			})
		})
	}

/*
 * Header fixed
*/
	const headerScroll = _ => {
		const siteDocument = document.documentElement
		const scrollElements = document.querySelectorAll('.header--offset')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					siteDocument.classList.add('is--scrolled')
				} else {
					siteDocument.classList.remove('is--scrolled')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '0px 0px 0px 0px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


	window.addEventListener('load', function () {
		headerScroll()
	})
